import {MenuItemConfig} from '@common/menus/menu-config';
import {Trans} from '@ui/i18n/trans';
import {useSelectedLocale} from '@ui/i18n/selected-locale';
import {Fragment} from 'react';

interface Props {
  item: MenuItemConfig;
}

// Resolve a menu item's link text for the active language. An explicit
// per-language label (set in the menu editor) wins; otherwise the base label
// is rendered through <Trans>, which still allows translating it via the
// global localization keys for backward compatibility.
export function MenuItemLabel({item}: Props) {
  const {localeCode} = useSelectedLocale();
  const translated = item.label_translations?.[localeCode];
  if (translated) {
    return <Fragment>{translated}</Fragment>;
  }
  return <Trans message={item.label} />;
}
